import { render, staticRenderFns } from "./thank-you-page.vue?vue&type=template&id=056a0ad2&scoped=true&"
import script from "./thank-you-page.vue?vue&type=script&lang=js&"
export * from "./thank-you-page.vue?vue&type=script&lang=js&"
import style0 from "./thank-you-page.vue?vue&type=style&index=0&id=056a0ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056a0ad2",
  null
  
)

export default component.exports